import styled from 'styled-components';
import { description } from './constants';

export const CloseButton = styled.button`
  all: unset;
  background: #0000008c;
  border-radius: 50%;
  width: 32px;
  height: 32px;

  display: flex;
  justify-content: center;
  align-items: center;

  svg > * {
    stroke: ${({ theme }) => theme.color.icon.neutral.inverted};
  }
`;

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;

  ${CloseButton} {
    position: absolute;
    top: ${({ theme }) => theme.spacing.km8};
    left: ${({ theme }) => theme.spacing.km8};
    z-index: 9;
  }
`;

export const Placeholder = styled.div.attrs({
  id: 'box-camera',
  'data-testid': 'camera',
})<{ isSelfie?: boolean }>`
  position: fixed;
  left: 0;
  top: 0;
  background: #000;
  height: 100vh;
  width: 100vw;

  display: flex;
  justify-content: center;
  align-items: center;

  #box--document-info {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }

  #label--document {
    font-size: ${({ theme }) => theme.font.size.m3} !important;
    font-weight: ${({ theme }) => theme.font.weight.bold} !important;
    color: ${({ theme }) => theme.color.text.neutral.strong} !important;
    position: initial !important;

    @media (max-height: 680px) {
      margin-top: ${({ theme }) => theme.spacing.km3} !important;
    }

    ::after {
      content: ${({ isSelfie }) =>
        isSelfie
          ? `"${description.selfie}"`
          : `"${description.documents}"`} !important;
      display: block !important;
      font-size: ${({ theme }) => theme.font.size.m2} !important;
      font-weight: ${({ theme }) => theme.font.weight.medium} !important;
      color: ${({ theme }) => theme.color.text.neutral.default} !important;
      max-width: 80% !important;
      margin: auto !important;
    }
  }

  #close_camera_container {
    display: none;
  }
`;

export const LoadingPositioner = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.km8};
  justify-content: center;
  align-items: center;
`;
